import React, { useMemo } from 'react'
import { FiArrowLeft } from 'react-icons/fi'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Carousel from '../../components/Carousel'
import cromatica from '../../constants/Cromatica'
import useLanguage from '../../hooks/useLanguage'
import {getColorTemplate} from '../../services/ColoringAndContrastHelpers'
import '../../styles/containers/Sheet.css'

const Sheet = props => {
  const { goBack } = useHistory()

  const orderByRankNumber = personalColoring => {
    const images = personalColoring
      .slice()
      .sort((a, b) => a.rankNumber - b.rankNumber)
      .map(({ image }) => ({ image }))

    return images
  }

  const language = useLanguage()
  const carouselPhotos = useMemo(() => {
  const userPersonalColor = props.user.userPersonalColor

  // Filtra apenas material próprio (subgroup_id null)
  const ownMaterialImages = userPersonalColor
      ? userPersonalColor.filter(img => img.subgroup_id == null)
      : []

    return ownMaterialImages.length > 0
      ? orderByRankNumber(ownMaterialImages)
      : getColorTemplate(props.user.personalColoring).map(image => ({ image }))
  }, [props.user.userPersonalColor, props.user.personalColoring, language])

  return (
    <div className='sheet-screen-container'>
      <div className='sheet-screen-title'>
        <FiArrowLeft onClick={() => goBack()}
          size={24} color='var(--primary)' className='sheet-screen-goback' />
        <p>{cromatica.onlineCard[language]}</p>
      </div>
      <Carousel photos={carouselPhotos} isColoring/>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, null)(Sheet)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/Sheet.js